import { c as _c } from "react/compiler-runtime";
import { useMachine } from '@xstate/react';
import constate from 'constate';
import type { MachineContext } from '../../utils/state-machine';
import { createLivenessMachine } from '../../utils/state-machine/machine';
type MachineArgs = {
  initialContext: MachineContext;
};
const useLocalLivenessMachine = t0 => {
  const $ = _c(2);
  const {
    initialContext
  } = t0;
  let t1;
  if ($[0] !== initialContext) {
    t1 = () => createLivenessMachine(initialContext);
    $[0] = initialContext;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useMachine(t1);
};
export const [MachineProvider, useLivenessMachine] = constate(useLocalLivenessMachine);
export default MachineProvider;